import { Link } from "react-router-dom";
import { config } from "../lib/config";

export function Logo({ linkTo = "/", className = "" }) {
  const img = (
    <img
      src={config.logoUrl}
      alt={config.brandName}
      className="h-auto w-[120px] sm:w-[160px]"
      draggable="false"
    />
  );
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      {linkTo ? (
        <Link to={linkTo} data-testid="nav-logo" className="flex items-center gap-3">
          {img}
        </Link>
      ) : (
        img
      )}
    </span>
  );
}
